import useIsMobile from 'utils/hooks/useIsMobile'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import {
  Backdrop,
  Button,
  Chip,
  MenuItem,
  Modal,
  Select,
  TextField,
} from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import {envBackHost, envImagePath, hdmImageBackHost, serverLocalName} from 'GLOBAL/envVariables'
import {yMarker} from 'assets/imageDeclear'
import dayjs from 'dayjs'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import _ from 'lodash'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {confirmAlert, normalAlert, resultAlert} from 'utils/CustomAlert/Alert'
import {formatDateOrEmpty} from 'utils/func/justUtils'
import {globalFormatWithHyphens, globalSerialNumberFormatWithHyphens} from 'utils/const/globalConst'
import {showBusanInfoHandler} from 'utils/const/globalController'
import useMobileBackClose from 'utils/hooks/useMobileBackClose'
import './print.css'

const customerUpdateDataInit = {
  customerNumber: null,
  officeId: null,
  customerTypeId: null,
  customerWorkTypeId: null,
  customerName: null,
  addressRoad: null,
  addressNumber: null,
  addressDetail: null,
  phoneNumber: null,
  managerName: null,
  filter2: null,
  meterNumber: null,
  meterDiameter: null,
  checkMonth: null,
  checkDay: null,
  memo: null,
  outerCase: null,
  outerCaseSize: null,
  externalDisplay: null,
}

const CustomerDetailInfoModal = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *****************************g****************************************/
  const isMobile = useIsMobile()
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '90%' : '70%',
    /* 모바일은 내용만큼 늘어나고 모달 자체에서만 스크롤한다 */
    height: isMobile ? 'auto' : '90%',
    maxHeight: '90%',
    bgcolor: 'background.paper',
    overflowY: 'auto',
    borderRadius: '12px',
    boxShadow: 24,
    p: isMobile ? 2 : 4,
  }
  const userInfo = useSelector((state: any) => state?.userInfo)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const {data, open, onClose, getList, page = 'default'} = props
  useMobileBackClose(open, onClose)

  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [updateFlag, setUpdateFlag] = useState(false)
  const [workType, setWorkType] = useState<any[]>([])
  const [customerType, setCustomerType] = useState<any[]>([])
  const [customerUpdateData, setCustomerUpdateData] = useState<any>(customerUpdateDataInit)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const getWorkType = () => {
    axiosWithAuth()
      .get(`/office/${data?.officeId}/customerworktype`)
      .then((res) => {
        setWorkType(res.data.res)
      })
  }
  const getCustomerType = () => {
    axiosWithAuth()
      .get(`/office/${data?.officeId}/customertype`)

      .then((res) => {
        setCustomerType(res.data.res)
      })
  }

  /**
   * 계정 권한별 수정 기능 ON OFF
   * @param type
   * @returns boolean
   */
  const accountTypeFixHandler = (type: string) => {
    switch (type) {
      case 'gov_meterman':
      case 'gov_coop':
      case 'manu_cust':
        return false
      default:
        return true
    }
  }

  /**
   *  부산 현황 페이지에서만 수정 기능 막기위해 만든 handler
   * @param page 정보관리인지 아니면 현황인지
   * @returns
   */
  const busanHandler = (page: any) => {
    switch (page) {
      case 'status':
        return false
      default:
        return true
    }
  }

  /**
   * 현재 부산 이외
   * @param serverName
   * @param officeId
   * @returns
   */
  const officeIdFixHandler = (serverName: string, officeId: string) => {
    const officeIdTwoDigit = String(officeInfo.value).slice(0, 2)
    switch (serverName) {
      case 'prod':
      case 'dev':
        switch (officeIdTwoDigit) {
          case '13':
            return busanHandler(page)
          default:
            return true
        }
      default:
        return true
    }
  }

  const patchButton = (state: boolean) => {
    if (state) {
    } else {
      setCustomerUpdateData({
        customerNumber: data?.customerNumber,
        officeId: data?.officeId,
        customerTypeId: data?.customerTypeId,
        customerWorkTypeId: data?.customerWorkTypeId,
        addressRoad: data?.addressRoad,
        addressNumber: data?.addressNumber,
        addressDetail: data?.addressDetail,
        phoneNumber: data?.phoneNumber,
        managerName: data?.managerName,
        filter2: data?.filter2,
        meterNumber: data?.meterNumber,
        meterDiameter: data?.meterDiameter,
        checkMonth: data?.checkMonth,
        checkDay: data?.checkDay,
        memo: data?.memo,
        customerName: data?.customerName,
        outerCase: data?.outerCase,
        outerCaseSize: data?.outerCaseSize,
        externalDisplay: data?.externalDisplay,
      })
    }
    setUpdateFlag(state)
  }

  const putCustomerUpdate = async () => {
    if (
      customerUpdateData.customerWorkTypeId === data.customerWorkTypeId &&
      customerUpdateData.customerTypeId === data.customerTypeId &&
      customerUpdateData.customerName === data.customerName &&
      customerUpdateData.phoneNumber === data.phoneNumber &&
      customerUpdateData.addressRoad === data.addressRoad &&
      customerUpdateData.addressNumber === data.addressNumber &&
      customerUpdateData.addressDetail === data.addressDetail &&
      customerUpdateData.managerName === data.managerName &&
      customerUpdateData.meterNumber === data.meterNumber &&
      customerUpdateData.meterDiameter === data.meterDiameter &&
      customerUpdateData.checkMonth === data.checkMonth &&
      customerUpdateData.checkDay === data.checkDay &&
      customerUpdateData.memo === data.memo &&
      customerUpdateData.filter2 === data.filter2
    ) {
      await normalAlert('수정된 내용이 없습니다.')
      return
    }
    if (await confirmAlert('수정', 'info')) {
      axiosWithAuth()
        .put(`${envBackHost}/customerinfo`, customerUpdateData)
        .then(async (res) => {
          console.log('!', res)
          await resultAlert(res.data)
          if (res.data.resultCode === 0) {
            getList()
            setUpdateFlag(false)
            return
          }
        })
        .catch(async (e) => {
          await resultAlert({resultCode: e.response.status})
        })
    } else {
      return
    }
  }

  useEffect(() => {
    getWorkType()
    getCustomerType()
    if (open === true) {
      setCustomerUpdateData({
        customerNumber: data?.customerNumber,
        officeId: data?.officeId,
        customerTypeId: data?.customerTypeId,
        customerWorkTypeId: data?.customerWorkTypeId,
        addressRoad: data?.addressRoad,
        addressNumber: data?.addressNumber,
        addressDetail: data?.addressDetail,
        phoneNumber: data?.phoneNumber,
        managerName: data?.managerName,
        filter2: data?.filter2,
        meterNumber: data?.meterNumber,
        meterDiameter: data?.meterDiameter,
        checkMonth: data?.checkMonth,
        checkDay: data?.checkDay,
        memo: data?.memo,
        customerName: data?.customerName,
        outerCase: data?.outerCase,
        outerCaseSize: data?.outerCaseSize,
        externalDisplay: data?.externalDisplay,
      })
    }

  }, [data, open])

  useEffect(() => {
    if (data && data.latitude && data.longitude) {
      setTimeout(() => {
        if (!window.kakao?.maps) {
          console.log('[CustomerDetailInfoMdal] kakao maps not loaded')
          return
        }
        let container = document?.getElementById('dashboard-detail-map')
        if (container) {
          const map = new window.kakao.maps.Map(container, {
            center: new window.kakao.maps.LatLng(data.latitude, data.longitude),
            mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
            level: 1,
            draggable: false,
            scrollwheel: false,
            zoomable: false,
          })
          // const mapTypeControl = new window.kakao.maps.MapTypeControl()
          // map.addControl(mapTypeControl, window.kakao.maps.ControlPosition.TOPRIGHT)
          var markerPosition = new window.kakao.maps.LatLng(data.latitude, data.longitude)

          var marker = new window.kakao.maps.Marker({
            position: markerPosition,
            image: new window.kakao.maps.MarkerImage(yMarker, new window.kakao.maps.Size(40, 59)),
          })

          marker.setMap(map)
        }
      }, 300)
    }
  }, [data, open])

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose()
        setUpdateFlag(false)
        setCustomerUpdateData(customerUpdateDataInit)
      }}
      aria-labelledby={`${window.location.pathname}-label`}
      aria-describedby={`${window.location.pathname}-description`}
      closeAfterTransition
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      id={'printTarget'}
      className={'printTarget'}
    >
      <Box sx={style}>
        <>
          <div>
            {/* 헤더: 이름 + 닫기 버튼 */}
            <div className='flex justify-between items-start mb-2 gap-2'>
              <Chip
                label={
                  /* 모바일은 수용가명만. '수용가 상세정보'는 자명하고,
                     담당자는 아래 수용가 정보 폼에 필드로 이미 있다. */
                  <div>
                    <strong className={'text-primary'}>{data?.customerName}</strong>
                    {!isMobile && (
                      <>
                        <span> 수용가 상세정보</span>
                        {data?.managerName && <span> 담당자 : {data?.managerName}</span>}
                      </>
                    )}
                  </div>
                }
                variant={'outlined'}
                sx={{
                  fontSize: isMobile ? '22px' : '20px',
                  fontWeight: 'bold',
                  height: '100%',
                  maxWidth: 'calc(100% - 48px)',
                  '& .MuiChip-label': {whiteSpace: 'normal', wordBreak: 'break-word'},
                }}
              />
              <CancelPresentationIcon
                sx={{fontSize: '40px', cursor: 'pointer', flexShrink: 0}}
                color={'error'}
                onClick={() => {
                  onClose()
                  setUpdateFlag(false)
                  setCustomerUpdateData(customerUpdateDataInit)
                }}
              />
            </div>

            {/* 본문 */}
            <div>
              {data && (
                <>
                  <div
                    className='flex flex-col lg:flex-row gap-4'
                    style={{height: isMobile ? 'auto' : 'calc(90vh - 140px)'}}
                  >
                    {/* 왼쪽: 수용가 정보 폼 */}
                    <div className='w-full lg:w-5/12 min-w-0 flex flex-col'>
                      <div className='border border-1 border-gray-400 shadow-sm px-0 flex flex-col flex-1 min-h-0'>
                        <Paper className='p-4 border-bottom border-1 border-gray-400' square>
                          <div className='flex justify-between w-full items-center'>
                            <span className='font-semibold text-[1.25rem]'>수용가 정보</span>
                            <div className='flex gap-3'>
                              <Button
                                variant={'outlined'}
                                color={'success'}
                                onClick={() => putCustomerUpdate()}
                                hidden={!updateFlag}
                              >
                                수정완료
                              </Button>
                              {accountTypeFixHandler(userInfo?.userInfo.accountType) &&
                                officeIdFixHandler(serverLocalName, officeInfo.value) && (
                                  <Button
                                    variant={'outlined'}
                                    color={!updateFlag ? 'error' : 'warning'}
                                    onClick={() => patchButton(!updateFlag)}
                                  >
                                    {!updateFlag ? '수정' : '취소'}
                                  </Button>
                                )}
                            </div>
                          </div>
                        </Paper>
                        <Paper
                          className={'p-4'}
                          square
                          style={
                            isMobile
                              ? {}
                              : {maxHeight: 'calc(100vh - 300px)', overflow: 'auto'}
                          }
                          sx={
                            !isMobile
                              ? {'& .MuiInputBase-root': {height: 48}}
                              : {
                                  /* 각 입력 필드에 걸린 mx-2(부트스트랩 유틸이라 !important) 를
                                     모바일에서만 무효화해 라벨과 입력창의 좌우 끝을 맞춘다.
                                     TextField 는 FormControl, 단독 Select 는 InputBase 가 루트라
                                     두 선택자를 모두 지정해야 폭이 같아진다.
                                     검침일 줄처럼 의도적으로 폭이 다른 필드는 한 단계 더 깊이
                                     있으므로 직계 자식만 대상으로 한다. */
                                  '& > .row > div > .MuiFormControl-root, & > .row > div > .MuiInputBase-root':
                                    {
                                      margin: '0 !important',
                                      width: '100% !important',
                                    },
                                }
                          }
                        >
                          <div className={'row gap-2'}>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 사업소
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={'mx-2 bg-gray-300'}
                                value={data?.officeName}
                                inputProps={{readOnly: true}}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 수용가 번호
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={'mx-2 bg-gray-300'}
                                value={globalFormatWithHyphens(
                                  data?.officeId,
                                  data?.customerNumber
                                )}
                                inputProps={{readOnly: true}}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 최초 설치일
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={'mx-2 bg-gray-300'}
                                value={formatDateOrEmpty(data?.installAt)}
                                inputProps={{readOnly: true}}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 수용가 종류
                              </span>
                              <Select
                                id='customer-target'
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data.customerTypeId}
                                inputProps={{readOnly: !updateFlag}}
                                sx={{width: '100%'}}
                                onChange={(e) => {
                                  setCustomerUpdateData((prev: any) => ({
                                    ...customerUpdateData,
                                    customerTypeId: Number(e.target.value),
                                  }))
                                }}
                              >
                                {customerType.map((el: any, i: number) => (
                                  <MenuItem key={i} value={el.customerTypeIdx}>
                                    {el.customerTypeName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 수용가 업종
                              </span>
                              <Select
                                labelId='demo-simple-select-label'
                                id='customer-workType'
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data.customerWorkTypeId}
                                inputProps={{readOnly: !updateFlag}}
                                sx={{width: '100%'}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    customerWorkTypeId: e.target.value,
                                  })
                                }}
                              >
                                {_.map(workType, (el: any, i) => (
                                  <MenuItem key={i} value={el.customerWorkTypeIdx}>
                                    {el.customerWorkTypeName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 이름
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.customerName}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    customerName: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 전화번호
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.phoneNumber}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  if (e.target.value?.includes('-')) {
                                    e.target.value = e.target.value.replaceAll('-', '')
                                  }
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    phoneNumber: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 도로명 주소
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.addressRoad}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    addressRoad: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 지번 주소
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.addressNumber}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    addressNumber: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 상세주소
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.addressDetail}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    addressDetail: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 담당자
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.managerName}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    managerName: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 담당자 전화번호
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.filter2}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    filter2: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 계량기 번호
                              </span>
                              <TextField
                                variant={'outlined'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                defaultValue={data?.meterNumber}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    meterNumber: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 구경 (단위 : mm)
                              </span>
                              <TextField
                                variant={'outlined'}
                                defaultValue={data?.meterDiameter}
                                type={'number'}
                                className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    meterDiameter: e.target.value,
                                  })
                                }}
                              />
                            </div>
                            {/* {outerInstallShowHandler(serverLocalName, officeInfo.value) && (
                              <>
                                <div className='flex flex-col gap-1 w-full'>
                                  <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                    <DoubleArrowIcon /> 외함 설치 유무
                                  </span>
                                  <Select
                                    id='customer-outerCase'
                                    className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                    defaultValue={customerUpdateData?.outerCase || ''}
                                    inputProps={{readOnly: !updateFlag}}
                                    sx={{width: '100%'}}
                                    onChange={(e) => {
                                      setCustomerUpdateData((prev: any) => ({
                                        ...prev,
                                        outerCase: Number(e.target.value),
                                      }))
                                    }}
                                  >
                                    <MenuItem key={0} value={''}>선택</MenuItem>
                                    <MenuItem key={1} value={'O'}>O</MenuItem>
                                    <MenuItem key={2} value={'X'}>X</MenuItem>
                                  </Select>
                                </div>
                                <div className='flex flex-col gap-1 w-full'>
                                  <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                    <DoubleArrowIcon /> 외함 사이즈
                                  </span>
                                  <Select
                                    id='customer-outerCaseSize'
                                    className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                    defaultValue={customerUpdateData?.outerCaseSize || ''}
                                    inputProps={{readOnly: !updateFlag}}
                                    sx={{width: '100%'}}
                                    onChange={(e) => {
                                      setCustomerUpdateData((prev: any) => ({
                                        ...prev,
                                        outerCaseSize: Number(e.target.value),
                                      }))
                                    }}
                                  >
                                    <MenuItem key={0} value={''}>선택</MenuItem>
                                    <MenuItem key={1} value={'S'}>소형</MenuItem>
                                    <MenuItem key={2} value={'L'}>대형</MenuItem>
                                  </Select>
                                </div>
                                <div className='flex flex-col gap-1 w-full'>
                                  <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                    <DoubleArrowIcon /> 외표기 설치 유무
                                  </span>
                                  <Select
                                    id='customer-externalDisplay'
                                    className={!updateFlag ? 'mx-2 bg-gray-300' : 'mx-2'}
                                    defaultValue={customerUpdateData?.externalDisplay || ''}
                                    inputProps={{readOnly: !updateFlag}}
                                    sx={{width: '100%'}}
                                    onChange={(e) => {
                                      setCustomerUpdateData((prev: any) => ({
                                        ...prev,
                                        externalDisplay: Number(e.target.value),
                                      }))
                                    }}
                                  >
                                    <MenuItem key={0} value={''}>선택</MenuItem>
                                    <MenuItem key={1} value={'O'}>O</MenuItem>
                                    <MenuItem key={2} value={'X'}>X</MenuItem>
                                  </Select>
                                </div>
                              </>
                            )} */}
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 검침일
                              </span>
                              <div className='flex gap-2'>
                                <Select
                                  labelId='demo-simple-select-label'
                                  id='customer-checkMonth'
                                  sx={{flex: 1}}
                                  className={!updateFlag ? 'bg-gray-300' : ''}
                                  defaultValue={data?.checkMonth === '당월' ? 10 : 20}
                                  inputProps={{readOnly: !updateFlag}}
                                  onChange={(e) => {
                                    setCustomerUpdateData({
                                      ...customerUpdateData,
                                      checkMonth: e.target.value === 10 ? '당월' : '전월',
                                    })
                                  }}
                                >
                                  <MenuItem value={10}>당월</MenuItem>
                                  <MenuItem value={20}>전월</MenuItem>
                                </Select>
                                <TextField
                                  variant={'outlined'}
                                  className={!updateFlag ? 'bg-gray-300' : ''}
                                  defaultValue={data?.checkDay}
                                  sx={{width: 80}}
                                  type={'number'}
                                  inputProps={{readOnly: !updateFlag}}
                                  onChange={(e) => {
                                    setCustomerUpdateData({
                                      ...customerUpdateData,
                                      checkDay: e.target.value,
                                    })
                                  }}
                                />
                              </div>
                            </div>
                            <div className='flex flex-col gap-1 w-full'>
                              <span className='flex items-center gap-2 font-semibold text-[1.25rem]'>
                                <DoubleArrowIcon /> 메모
                              </span>
                              <TextField
                                variant={'outlined'}
                                sx={{width: '100%', '& .MuiInputBase-root': {height: 'auto'}}}
                                defaultValue={data?.memo}
                                type={'text'}
                                multiline
                                minRows={1}
                                maxRows={5}
                                className={!updateFlag ? 'bg-gray-300' : ''}
                                inputProps={{readOnly: !updateFlag}}
                                onChange={(e) => {
                                  setCustomerUpdateData({
                                    ...customerUpdateData,
                                    memo: e.target.value,
                                  })
                                }}
                              />
                            </div>
                          </div>
                        </Paper>
                      </div>
                    </div>

                    {/* 오른쪽: 지도 + 단말기 정보 */}
                    <div className='flex-1 min-w-0'>
                      <div
                        className='flex flex-col gap-3'
                        style={{height: isMobile ? 'auto' : 'calc(100vh - 236px)'}}
                      >
                        <div
                          id='dashboard-detail-map'
                          style={
                            isMobile
                              ? {width: '100%', height: 240}
                              : {width: '100%', flex: 1, minHeight: 0}
                          }
                          onClick={() => {
                            showBusanInfoHandler(serverLocalName, officeInfo.value) &&
                              window.open(
                                `https://m.map.kakao.com/scheme/search?q=${data.addressRoad}&center=me`,
                                '_blank'
                              )
                          }}
                          className={`rounded-2 border-gray-400 border border-1 ${
                            showBusanInfoHandler(serverLocalName, officeInfo.value)
                              ? 'cursor-pointer'
                              : ''
                          }`}
                        />
                        <div className='text-end'>
                          {showBusanInfoHandler(serverLocalName, officeInfo.value) && (
                            <span className={'text-danger fw-bold text-end'}>
                              지도를 클릭하면 카카오맵으로 이동합니다.
                            </span>
                          )}
                        </div>
                        <Chip
                          label={
                            <span>
                              연결된 단말기 :
                              <strong className={'text-success'}>
                                {' '}
                                {globalSerialNumberFormatWithHyphens(data?.serialNumber)}
                              </strong>
                            </span>
                          }
                          variant={'outlined'}
                          sx={{fontSize: '20px', fontWeight: 'bold'}}
                        />
                        <div className='w-full border border-gray-400 rounded-3 p-3'>
                          <div className='flex flex-col items-center text-center gap-2'>
                            <div className='w-full flex flex-col items-center'>
                              {(data?.filePath || data?.latestImageFilePath) && (
                                <img
                                  src={
                                    data?.deviceType !== 'hdm'
                                      ? envImagePath + data?.filePath
                                      : `${hdmImageBackHost}/api/select/${data?.latestImageFilePath}`
                                  }
                                  alt='metering-image'
                                  style={{
                                    transform: `rotate(${data?.rotate}deg)`,
                                    maxWidth: '100%',
                                  }}
                                  width={320}
                                  height={144}
                                />
                              )}
                              <div className={'mt-2 fw-bold fs-4'}>
                                {data?.deviceType !== 'hdm' && (
                                  <span>
                                    {dayjs(data?.deviceConnectAt).format('YYYY년 MM월 DD일 HH:mm:ss')}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className='flex w-full fw-bold fs-3 text-center border border-gray-400 border-1 rounded-2'>
                              <div className={'col-5 row gap-3 align-items-center text-start p-2'}>
                                <span>단말기 상태</span>
                                {data?.deviceType !== 'hdm' && <span>펌웨어</span>}
                                <span>신호강도</span>
                                <span>서버주기</span>
                                {data?.deviceType === 'hdm' && <span>마지막 전송일시</span>}
                              </div>
                              <div className={'col row gap-3 text-start align-items-center p-2'}>
                                <span>
                                  {data?.deviceStatus === true ? (
                                    <span className={'text-primary'}>정상</span>
                                  ) : (
                                    <span className={'text-danger'}>점검</span>
                                  )}
                                </span>
                                {data?.deviceType !== 'hdm' && <span>{data?.deviceVersion}</span>}

                                <span>{data?.signalStrength}dBm</span>
                                <span>{data?.serverCycle} H</span>
                                {data?.deviceType === 'hdm' && (
                                  <span>
                                    {dayjs(data?.deviceConnectAt).format(
                                      'YYYY년 MM월 DD일 HH시 mm분 ss초'
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className={'mt-5 fs-5 fw-bold ms-4 text-center'}>
                            {data?.deviceApplyStatus === true ? (
                              <span className={'text-danger'}>
                                업데이트 대기 중인 단말기 입니다.
                              </span>
                            ) : (
                              <span className={'text-primary'}>업데이트 내용이 없습니다.</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      </Box>
    </Modal>
  )
}
export default CustomerDetailInfoModal
